import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Stack, TextField,
  Button, ToggleButtonGroup, ToggleButton, IconButton, Typography, Box,
  useMediaQuery, useTheme,
} from '@mui/material';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ModalHeader from '../ui/ModalHeader';

export function FinishJobDialog({
  open, result, onResultChange, poNumber, onPoNumberChange, value, onValueChange, note, onNoteChange,
  docs, onAddDoc, onRemoveDoc, onDocNameChange, onDocFileChange,
  saving, onClose, onConfirm, hideResultToggle,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 3 } }}
    >
      <ModalHeader
        icon={<FlagOutlinedIcon fontSize="small" />}
        title="จบงาน"
        onClose={onClose}
        disabled={saving}
        color="success"
      />
      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={2.5}>
          {!hideResultToggle && (
            <ToggleButtonGroup
              exclusive fullWidth
              value={result}
              onChange={(e, v) => v && onResultChange(v)}
              sx={{
                '& .MuiToggleButton-root.Mui-selected': {
                  '&[value="WON"]': { bgcolor: 'success.main', color: 'success.contrastText', '&:hover': { bgcolor: 'success.dark' } },
                  '&[value="LOST"]': { bgcolor: 'error.main', color: 'error.contrastText', '&:hover': { bgcolor: 'error.dark' } },
                },
              }}
            >
              <ToggleButton value="WON">ได้งาน</ToggleButton>
              <ToggleButton value="LOST">ไม่ได้งาน</ToggleButton>
            </ToggleButtonGroup>
          )}

          {result === 'WON' && (
            <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
              <TextField
                label="มูลค่างาน" size="small" type="number"
                value={value}
                onChange={(e) => onValueChange(e.target.value)}
                sx={{ flex: '1 1 160px' }}
              />
              <TextField
                label="เลขที่ PO" size="small"
                value={poNumber}
                onChange={(e) => onPoNumberChange(e.target.value)}
                sx={{ flex: '1 1 160px' }}
              />
            </Stack>
          )}

          <TextField
            label="หมายเหตุ" size="small" fullWidth multiline rows={2}
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
          />

          {result === 'WON' && (
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.4, fontWeight: 600 }}>
                เอกสารแนบ
              </Typography>
              <Stack spacing={1} sx={{ mt: 1 }}>
                {docs.map((row) => (
                  <Stack
                    key={row.rowId} direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap
                    sx={{ p: 1, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}
                  >
                    <TextField
                      size="small" variant="standard" label="ชื่อเอกสาร" placeholder="เช่น ใบสั่งซื้อ, ใบส่งมอบงาน"
                      value={row.name}
                      onChange={(e) => onDocNameChange(row.rowId, e.target.value)}
                      sx={{ flex: 1 }}
                    />
                    <Button component="label" size="small" variant="text" startIcon={<AttachFileIcon fontSize="small" />} sx={{ whiteSpace: 'nowrap' }}>
                      {row.file ? row.file.name : 'เลือกไฟล์'}
                      <input type="file" hidden onChange={(e) => onDocFileChange(row.rowId, e.target.files?.[0] || null)} />
                    </Button>
                    <IconButton size="small" color="error" onClick={() => onRemoveDoc(row.rowId)}>
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                ))}
              </Stack>
              <Button size="small" startIcon={<AddIcon />} onClick={onAddDoc} sx={{ mt: 1 }}>
                เพิ่มเอกสาร
              </Button>
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }} disabled={saving}>ยกเลิก</Button>
        <Button onClick={onConfirm} variant="contained" color="success" disabled={saving} sx={{ borderRadius: 2 }}>
          {saving ? 'กำลังบันทึก...' : 'ยืนยันจบงาน'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FinishJobDialog;
